import { gql } from '@apollo/client';
import type { ProvisionRegisterUrl_ProvisionFragment } from '../../graphql/generated/graphqlTypes';

const PROVISION_FRAGMENT = gql`
  fragment provisionRegisterUrl_provision on Provision {
    id
    secret
  }
`;

export default function provisionRegisterUrl(
  provision: ProvisionRegisterUrl_ProvisionFragment,
) {
  return (
    provision.id &&
    provision.secret &&
    `https://${window.__slab.ORG_HOST}/register/${provision.id}/${provision.secret}`
  );
}

provisionRegisterUrl.fragments = {
  provision: PROVISION_FRAGMENT,
};
